export default [
  {
    "path": "/superdeer-activity/group-team/index",
    "name": "group-team",
    "meta": { "title": "团课战队", "headerType": 2 },
    component: () => import('../views/superdeer-activity/group-team/index')
  },
  {
    "path": "/superdeer-activity/group-team/course-list",
    "name": "group-team-course-list",
    "meta": { "title": "团课积分明细", "headerType": 2 },
    component: () => import('../views/superdeer-activity/group-team/course-list')
  },
  {
    "path": "/superdeer-activity/group-team/team-record",
    "name": "group-team-team-record",
    "meta": { "title": "我的组队记录", "headerType": 2 },
    component: () => import('../views/superdeer-activity/group-team/team-record')
  },
  {
    "path": "/superdeer-activity/group-team/receive",
    "name": "/superdeer-activity/group-team/receive",
    "meta": { "title": "奖品领取确认", "headerType": 5 },
    component: () => import('../views/superdeer-activity/group-team/receive.vue')
  },
  {
    "path": "/joinCompany/index",
    "name": "join-company",
    "meta": { "title": "超鹿运动", "headerType": 2 },
    component: () => import('../views/joinCompany/index')
  },
  {
    "path": "/teacher-detail/score",
    "name": "/teacher-detail/score",
    "meta": { "title": "私教评分", "headerType": 5 },
    component: () => import('../views/teacher-detail/score.vue')
  },
  {
    "path": "/teacher-detail/share",
    "name": "/teacher-detail/share",
    "meta": { "title": "", "headerType": 5 },
    component: () => import('../views/teacher-detail/share.vue')
  },
  {
    "path": "/teacher-detail/ranking",
    "name": "/teacher-detail/ranking",
    "meta": { "title": "私教分排行榜", "headerType": 5 },
    component: () => import('../views/teacher-detail/ranking.vue')
  },
  {
    "path": "/superdeer-activity/new-year-buy-2025",
    "name": "/new-year-buy-2025",
    "meta": { "title": "新春购", "headerType": 4 },
    component: () => import('../views/superdeer-activity/new-year-buy-2025/index.vue')
  },
  {
    "path": "/superdeer-activity/new-year-buy-2026",
    "name": "/new-year-buy-2026",
    "meta": { "title": "春节购", "headerType": 4 },
    component: () => import('../views/superdeer-activity/new-year-buy-2026/index.vue')
  },
  {
    "path": "/superdeer-activity/new-year-buy-2026/shop",
    "name": "superdeer-activity/new-year-buy-2026/shop",
    "meta": { "title": "超鹿7周年·热销商品", "headerType": 5 },
    component: () => import('../views/superdeer-activity/new-year-buy-2026/shop.vue')
  },
  {
    "path": "/superdeer-activity/spring-awakening-2025/marketing/index",
    "name": "superdeer-activity/spring-awakening-2025/marketing",
    "meta": { "title": "超鹿3月春醒", "headerType": 4 },
    component: () => import(/* webpackChunkName: "sell" */'../views/superdeer-activity/spring-awakening-2025/marketing/index.vue')
  },
  {
    "path": "/superdeer-activity/spring-awakening-2025/marketing/index2",
    "name": "superdeer-activity/spring-awakening-2025/marketing",
    "meta": { "title": "超鹿3月春醒", "headerType": 4 },
    component: () => import(/* webpackChunkName: "sell" */'../views/superdeer-activity/spring-awakening-2025/marketing/index3.vue')
  },
  {
    "path": "/superdeer-activity/spring-awakening-2025/marketing/baoyue",
    "name": "superdeer-activity/spring-awakening-2025/marketing-baoyue",
    "meta": { "title": "超鹿3月春醒", "headerType": 4 },
    component: () => import(/* webpackChunkName: "sell" */'../views/superdeer-activity/spring-awakening-2025/marketing/baoyue.vue')
  },
  {
    "path": "/superdeer-activity/spring-awakening-2025/marketing/guangzhou",
    "name": "superdeer-activity/spring-awakening-2025/marketing-guangzhou",
    "meta": { "title": "超鹿88大促", "headerType": 4 },
    component: () => import(/* webpackChunkName: "sell" */'../views/superdeer-activity/spring-awakening-2025/marketing/guangzhou.vue')
  },
  {
    "path": "/superdeer-activity/anniversary-2025/lottery",
    "name": "superdeer-activity/anniversary-2025/lottery",
    "meta": { "title": "运动刮刮乐", "headerType": 4 },
    component: () => import(/* webpackChunkName: "sell" */'../views/superdeer-activity/anniversary-2025/lottery/index.vue')
  },
  {
    "path": "/superdeer-activity/anniversary-2025/getGift",
    "name": "/superdeer-activity/anniversary-2025/getGift",
    "meta": { "title": "奖品领取确认", "headerType": 5 },
    component: () => import('../views/superdeer-activity/anniversary-2025/lottery/getGift.vue')
  },
  {
    "path": "/superdeer-activity/anniversary-2025/receive",
    "name": "/superdeer-activity/anniversary-2025/receive",
    "meta": { "title": "奖品领取确认", "headerType": 5 },
    component: () => import('../views/superdeer-activity/anniversary-2025/lottery/receive.vue')
  },
  {
    "path": "/superdeer-activity/anniversary-2025/invite",
    "name": "superdeer-activity/anniversary-2025/invite",
    "meta": { "title": "超鹿7周年，邀好友赢积分", "headerType": 4 },
    component: () => import(/* webpackChunkName: "anni2025" */'../views/superdeer-activity/anniversary-2025/invite/index.vue')
  },
  {
    "path": "/superdeer-activity/anniversary-2025/friend",
    "name": "superdeer-activity/anniversary-2025/friend",
    "meta": { "title": "超鹿7周年，邀好友赢积分", "headerType": 4 },
    component: () => import(/* webpackChunkName: "anni2025" */'../views/superdeer-activity/anniversary-2025/invite/friend.vue')
  },
  {
    "path": "/superdeer-activity/anniversary-2025/up-deposit",
    "name": "superdeer-activity/anniversary-2025//up-deposit",
    "meta": { "title": "定金升级活动", "headerType": 4 },
    component: () => import(/* webpackChunkName: "sell" */'../views/superdeer-activity/anniversary-2025/up-deposit/index.vue')
  },
  {
    "path": "/superdeer-activity/anniversary-2025/up",
    "name": "superdeer-activity/anniversary-2025/up",
    "meta": { "title": "定金升级活动", "headerType": 5 },
    component: () => import(/* webpackChunkName: "anni2025" */'../views/superdeer-activity/anniversary-2025/up-deposit/up.vue')
  },
  {
    "path": "/superdeer-activity/group-class-gz-2025",
    "name": "superdeer-activity/group-class-gz-2025",
    "meta": { "title": "上团课得阅宝黄金钥匙扣", "headerType": 4 },
    component: () => import(/* webpackChunkName: "group2025" */'../views/superdeer-activity/group-class-gz-2025/index.vue')
  },
  {
    "path": "/superdeer-activity/group-class-gz-2025ALL",
    "name": "superdeer-activity/group-class-gz-2025",
    "meta": { "title": "上团课得阅宝黄金钥匙扣", "headerType": 4 },
    component: () => import(/* webpackChunkName: "group2025" */'../views/superdeer-activity/group-class-gz-2025/index.vue')
  },
  {
    "path": "/superdeer-activity/group-class-gz-2025/record",
    "name": "/superdeer-activity/group-class-gz-2025/record",
    "meta": { "title": "团课记录", "headerType": 5 },
    component: () => import('../views/superdeer-activity/group-class-gz-2025/record.vue')
  },
  {
    "path": "/superdeer-activity/group-class-gz-2025/getGift",
    "name": "/superdeer-activity/group-class-gz-2025/getGift",
    "meta": { "title": "奖品领取确认", "headerType": 5 },
    component: () => import('../views/superdeer-activity/group-class-gz-2025/getGift.vue')
  },
  {
    "path": "/superdeer-activity/group-punching/202608",
    "name": "superdeer-activity/group-punching/202608",
    "meta": { "title": "超鹿早课课代表", "headerType": 2 },
    component: () => import(/* webpackChunkName: "group-punching-202608" */'../views/superdeer-activity/group-punching/202608.vue')
  },
  {
    "path": "/superdeer-activity/anniversary-2025/shop",
    "name": "superdeer-activity/anniversary-2025/friend",
    "meta": { "title": "超鹿7周年·热销商品", "headerType": 5 },
    component: () => import(/* webpackChunkName: "anni2025" */'../views/superdeer-activity/anniversary-2025/main/shop.vue')
  },
  {
    "path": "/superdeer-activity/group-buying",
    "name": "superdeer-activity/group-buying",
    "meta": { "title": "超鹿·拼团", "headerType": 5 },
    component: () => import('../views/superdeer-activity/group-buying/index.vue')
  },
  {
    "path": "/superdeer-activity/88sale/group-buying",
    "name": "superdeer-activity/88sale/group-buying",
    "meta": { "title": "年卡拼团", "headerType": 5 },
    component: () => import('../views/superdeer-activity/88sale/group-buying/index.vue')
  },
   {
    "path": "/superdeer-activity/group-buy",
    "name": "superdeer-activity/group-buy",
    "meta": { "title": "超鹿·拼团", "headerType": 5 },
    component: () => import('../views/superdeer-activity/group-buy/index.vue')
  },
   {
    "path": "/superdeer-activity/spring-awakening-2026/customize-deposit",
    "name": "superdeer-activity/spring-awakening-2026/customize-deposit",
    "meta": { "title": "超鹿3月春醒", "headerType": 4 },
    component: () => import(/* webpackChunkName: "sell-spring-awakening-2026" */'../views/superdeer-activity/spring-awakening-2026/customize-deposit/index.vue')
  },
]
